import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import styled from "styled-components"
import * as StringTools from '~/utilities/string'

import SimpleInput from '~/components/Form/SimpleInput'
import InputItemWrapper from '~/components/Form/InputItemWrapper'
import MoneyIcon from "~/public/static/images/svg/money.svg"

const Wrapper = styled.div`
  display: flex;
  border-radius: 8px;
  transition: all 500ms ease;
  border: ${({ error, theme: { colors } }) => `1px solid ${error ? colors.error : colors.ui.inputBorder}`};
`

const IconBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 7px 0px 13px;
`

@inject((all, props) => ({
  ticket: props.ticket,
  disabled: props.disabled,
  autoFocus: props.autoFocus,
}))
@observer
class TicketIDInput extends Component {
  changeTicketID = e => {
    const { ticket } = this.props
    const { value } = e.target
    let safeValue = StringTools.replaceAll(value, ' ', '')
    safeValue = StringTools.replaceAll(safeValue, '-', '')
    ticket.changeKey('ticketID', safeValue.toUpperCase())
  }
  
  render() {
    const { ticket, autoFocus = true } = this.props
    const ticketIdError = ticket.validateDisplayMessage('ticketID')

    return (
      <InputItemWrapper label="Ticket ID" error={ticketIdError}>
        <Wrapper error={ticketIdError}>
          <IconBox>
            <img alt="Ticket Icon" src={MoneyIcon} />
          </IconBox>
          <SimpleInput
            id="ticketID"
            placeholder="AB3768273678"
            value={ticket.ticketID}
            onChange={this.changeTicketID}
            error={ticketIdError}
            autoFocus={autoFocus}
            textIndent="5px"
            noBorder
          />
        </Wrapper>
      </InputItemWrapper>
    )
  }
}

export default TicketIDInput
